import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { fetchInventoryTagItemCount } from '../../../sagas/components/edit-tag-modal/routines';

const initialState = {
  count: null,
  fetching: false,
  fetched: false
};

const fetchInventoryTagItemCountHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    fetching: true,
    fetched: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('count', response.count, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export default createReducer(initialState, {
  ...fetchInventoryTagItemCountHandler(fetchInventoryTagItemCount)
});
